import { setTrackView } from '@vfit/shared/data-access';
import { useTracking, AppMobile } from '@vfit/shared/data-access';
import { getUserInfo } from './vola.utils';
import { IVolaTagging } from './vola.models';

export const VolaTagging = ({ skill, desc, pageProduct, taggingOpts }: IVolaTagging) => {
  const techoffer = localStorage.getItem('techOffer') || '';
  const { trackView } = useTracking({
    event: ['journey_start'],
    event_label: 'Privati:CTC:CMN',
    opts: {
      ...taggingOpts,
      ...(skill && { channel: skill }),
      ...(desc && { desc }),
      event_category: 'journey',
      journey_type: 'journey',
      journey_name: 'CTC',
      versatile_prop: 'new ctc',
      ...(techoffer && { product_technology: techoffer }),
      ...(pageProduct && {
        ...pageProduct,
      }),
      page_name_forced_override: 'Privati:CTC:CMN',
    },
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  return null;
};
